<template>
  <section class="contact-section" data-aos="fade-up" data-aos-delay="300" data-aos-once="true">
      <b-container class="sweden-container">
        <b-row class="row request-form-header" v-if="showForm">
          <b-col class="col-12 col-lg-6 request-form-h1-wrapper">
            <h1 class="request-form-h1">Request to participate</h1>
            <p class="small"><i>All fields are required. </i></p>
          </b-col>
          <b-col class="col-12 col-lg-6 request-form-h2-wrapper">
            <h2 class="request-form-h2">Colmis, Arjeplog, Sweden</h2>
            <p class="event-details">February 23 - March 6, 2026</p>
          </b-col>
        </b-row>
        <b-row class="row request-form-details-row" v-if="showForm">
          <b-col class="col-12 col-lg-6 request-form-h3-wrapper"><h3 class="request-form-h3">Your contact information</h3></b-col>
          <b-col class="col-12 col-lg-6 request-form-h3-wrapper"><h3 class="request-form-h3">Your request</h3></b-col>
        </b-row>
        <b-row>
            <b-form id="swedenSignUp" class="swedenSignUp" name="swedenSignUp" @submit="submitRequestForm" v-if="showForm">
              <b-row class="mb-5">
                <b-col class="col-12 col-lg-6">
                  <b-form-group class="col-12 col-md-6">
                    <label for="firstName">First name</label>
                    <b-form-input id="firstName" v-model="form.firstName" type="text" required></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-12 col-md-6">
                    <label for="lastName">Last name</label>
                    <b-form-input id="lastName"  v-model="form.lastName" type="text" required></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-12">
                    <label for="email">Email</label>
                    <b-form-input id="email"  v-model="form.email" type="email" required></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-12">
                    <label for="titleRole">Title or Role</label>
                    <b-form-input id="titleRole" class="form-control" v-model="form.titleRole" required></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-12">
                    <label for="company">Company</label>
                    <b-form-textarea id="company"  v-model="form.company" placeholder="" required></b-form-textarea>
                  </b-form-group>
                  <b-form-group class="consent-text col-12">
                    <strong>
                      <p>By providing this information, you consent to receive scheduling updates regarding the Winter Grip event. This information will be processed consistent with our <a href="https://corporate.goodyear.com/us/en/more/terms-conditions-and-privacy-policy/global-privacy-policy.html" target="_blank">Privacy Policy</a>.</p>
                    </strong>
                  </b-form-group>
                </b-col>
                <b-col class="col-12 col-lg-6 group-size-and-dates">
                  <b-form-group class="groupSize-wrapper col-12">
                    <label for="groupSize">Group size</label>
                    <b-form-input id="groupSize" v-model="form.groupSize" type="number" required></b-form-input>
                  </b-form-group>
                  <b-form-checkbox-group
                      v-model="selectedDatesProxy"
                      name="selectedDates"
                      class="selected-dates col-12"
                    >
                    <label for="selectedDates">Availability (select at least one)</label>
                    <b-col class="col-12 d-flex flex-column">
                      <b-form-checkbox
                        v-for="date in dateOptions"
                        :key="date.value"
                        :value="date.value"
                        :disabled="isDisabled(date.value)"
                        class="pb-2"
                      >
                        {{ date.text }}
                      </b-form-checkbox>
                    </b-col>
                    <b-col>
                      <b-form-invalid-feedback :state="availabilityState">Please select at least one</b-form-invalid-feedback>
                    </b-col>
                    </b-form-checkbox-group>
                </b-col>
              </b-row>

              <b-row class="form-bottom-row">
                <b-col>
                  <b-form-group class="col-12">
                    <b-form-checkbox id="futureEventsOptIn" class="optInText futureEvents" v-model="form.futureEventsOptIn" placeholder="" required>
                      I also agree to receive occasional emails about future events, news, discounts and deals from Goodyear.
                    </b-form-checkbox>
                  </b-form-group>

                  <b-form-group  class="form-buttons col-12">
                    <vue-recaptcha :loadRecaptchaScript="true" @verify="onVerify" :sitekey="recaptchaSecret"></vue-recaptcha>
                    <p class="red">{{ this.invalidField }}</p>

                    <button type="submit" class="btn gy-primary swedenSubmitBtn" v-if="!loading">Submit Request</button>
                    <b-spinner label="Loading..." v-if="loading"></b-spinner>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <div class="success col" v-if="showThanks && !showForm">
              <h3>Thank you for your message!</h3>
              <p>We have received your request to participate.</p>
              <p>We will contact you shortly to discuss your proposed dates.</p>
            </div>

            <div class="fail col" v-if="showError && !showForm">
              <h3>Error</h3>
              <p>Please try again later.</p>
            </div>
        </b-row>
      </b-container>
    </section>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
window.dataLayer = window.dataLayer || []
export default {
  name: 'SwedenSignUp',
  data() {
      return {
        form: {
          firstName: '',
          lastName: '',
          email: '',
          titleRole: '',
          groupSize: '',
          company: '',
          selectedDates: [],
          futureEventsOptIn: false,
          gResponse: ''
        },
        showForm: true,
        invalidField: ' ',
        showThanks: false,
        showError: false,
        loading: false,
        dateOptions: [
          { text: 'Any Date', value: 'Any Date' },
          { text: 'Contact me for extra dates', value: 'Contact me for extra dates' },
          { text: 'February 23, 2026', value: 'Feb 23, 2026' },
          { text: 'February 24, 2026', value: 'Feb 24, 2026' },
          { text: 'February 25, 2026', value: 'Feb 25, 2026' },
          { text: 'February 26, 2026', value: 'Feb 26, 2026' },
          { text: 'February 27, 2026', value: 'Feb 27, 2026' },
          { text: 'March 2, 2026', value: 'Mar 2, 2026' },
          { text: 'March 3, 2026', value: 'Mar 3, 2026' },
          { text: 'March 4, 2026', value: 'Mar 4, 2026' },
          { text: 'March 5, 2026', value: 'Mar 5, 2026' },
          { text: 'March 6, 2026', value: 'Mar 6, 2026' }
        ],
        recaptchaSecret: process.env.RECAPTCHA_SECRET || '6LdzzzodAAAAAB2R9eTTGxpbzEx4zPxdMzF2Mzmc' // fallback for local development
      }
    },
    components : {
      VueRecaptcha
    },
    computed: {
      availabilityState() {
        return this.form.selectedDates.length >= 1
      },
      selectedDatesProxy: {
        get() {
          return this.form.selectedDates;
        },
        set(dates) {
          if (dates.includes("Any Date")) {
            // When Any Date is chosen: uncheck all others
            this.form.selectedDates = ["Any Date"];
          } else {
            // Ensure Any Date isn't sticking around if others are chosen
            this.form.selectedDates = dates.filter(v => v !== "Any Date");
          }
        },
      },
    },
    methods : {
      onVerify: function (response) {
        if (response) this.form.gResponse = response
      },
      isDisabled(date) {
        // Disable all other options while Any Date is selected
        return this.form.selectedDates.includes("Any Date") && date !== "Any Date" && date !== "Contact me for extra dates" && date !== "Contact me for extra dates";
      },
      submitRequestForm (evt) {
        evt.preventDefault()
        this.loading = true
        this.invalidField = ''
        // recaptcha
        if (this.form.gResponse.length == 0) {
            // reCaptcha not verified
            this.loading = false
            this.invalidField = 'Please verify using reCAPTCHA.'
            return false;
        }

        axios.post('/api/swedenSignUp', {
          form: this.form,
          name: 'swedenSignUp'
        })
          .then(response => {
            this.showForm = false
            this.loading = false
            if (response.data === 1) {
              this.showThanks = true
              window.dataLayer.push({ 'event': 'formSubmitted', 'formName': 'Request to Participate' })
            } else {
              this.showError = true
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2, h3 {
  color: #000000;
}
.contact-section {
  padding-bottom: 50px;
}
.contact-section .container {
  background-color: #fff;
  padding-top: 25px;
  padding-bottom: 25px;
}
.request-form-h1-wrapper, .request-form-h2-wrapper {
  text-align: left;
}
.request-form-h1 {
  font-weight: 500;
}
.request-form-h3 {
  font-size: 1.5rem;
  font-weight: 500;
}
.request-form-details-row {
  margin-top: 50px;
  margin-bottom: 15px;
}
.event-details {
  font-size: 1.3rem;
  font-weight: 300;
}
.groupSize-wrapper {
  z-index: 1;
}
.selected-dates {
  color:#000000;
}
.form-group {
  float: left;
}
.form-buttons {
  margin-bottom: 1.5rem;
  margin-top: 15px;
}
.form-control {
  border-radius: 0px;
  height: 45px;
  font-size: 18px
}
.success, .fail {
  font-style: italic;
  padding-top: 25px;
}
.success h3 {
  color: green;
  font-family: "Barlow", serif;
  font-weight: bold;
}
.fail h3 {
  color: red;
  font-family: "Barlow", serif;
  font-weight: bold;
}
.optInText {
  font-family: "Barlow", serif;
  font-weight: 400;
}
.swedenSubmitBtn {
  background-color: #000;
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  padding: 10px 20px;
  border-radius: 4px;
}

/* Extra Small Screens */
@media (max-width: 576px) {
  .sweden-container {
    padding: 10px;
  }
  .group-size-and-dates {
    /* padding: 0px 30px; */
  }
}

/* Small Screens */
@media (min-width: 576px) {
  .sweden-container {
    padding: 15px;
  }
}

/* Medium Screens */
@media (min-width: 768px) {
  .sweden-container {
    padding: 30px;
  }
}

/* Large Screens */
@media (min-width: 992px) {
  .sweden-container {
    padding: 60px;
  }
}

/* Extra Large Screens */
@media (min-width: 1200px) {
  .sweden-container {
    padding: 60px;
  }
}
</style>
